function Footer() {
  return (
    <footer>
      <div className="container">
        <p>&copy; 2025 Ebamba Travel & Tours. All rights reserved. Done by 
          <a href="https://nateanne.co.za/" target="_blank" className="nate-anne" rel="noreferrer"> Done by Nate~Anne</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
